<div
  *ngIf="control"
  class="dict-dobry-agent-blog-articles"
>
  <mat-form-field class="dict-dobry-agent-blog-articles__select">
    <mat-label>{{ label }}</mat-label>

    <mat-select
      [formControl]="control"
      [required]="required"
      [multiple]="multiple"
      (selectionChange)="onSelectionChange($event)"
    >
      <mat-option>
        <ngx-mat-select-search
          [formControl]="filterControl"
          placeholderLabel="Wyszukaj artykuł..."
          noEntriesFoundLabel="Nie znaleziono artykułu"
        >
        </ngx-mat-select-search>
      </mat-option>

      <mat-option
        *ngIf="!required && !multiple"
        [value]="null"
      >
        Brak
      </mat-option>

      <mat-option
        *ngIf="loading"
        disabled
      >
        <div class="article-loading">
          <mat-spinner diameter="20"></mat-spinner>
          <span>Wczytywanie...</span>
        </div>
      </mat-option>

      <mat-option
        *ngFor="let article of items"
        [value]="article.uuid"
        class="article-mat-option"
      >
        <div class="article-option">
          <div class="article-option__name">
            {{ article.name }}
          </div>

          <div
            class="article-option__meta"
            *ngIf="article.publicationDate"
          >
            {{ article.publicationDate | date:'yyyy-MM-dd HH:mm' }}
          </div>
        </div>
      </mat-option>

      <mat-option
        *ngIf="hasMore"
        class="article-load-more-option"
        (click)="loadMore($event)"
      >
        <div class="article-load-more">
          <mat-spinner
            *ngIf="loadingMore"
            diameter="20"
          ></mat-spinner>

          <mat-icon *ngIf="!loadingMore">
            expand_more
          </mat-icon>

          <span>
            {{ loadingMore ? 'Wczytywanie...' : 'Wczytaj więcej' }}
          </span>
        </div>
      </mat-option>
    </mat-select>

    <button
      *ngIf="hasSelectedArticles && !required && !control.disabled"
      matSuffix
      mat-icon-button
      type="button"
      aria-label="Wyczyść powiązane artykuły"
      (click)="clearValue(); $event.stopPropagation()"
    >
      <mat-icon>close</mat-icon>
    </button>

    <mat-error *ngIf="control.hasError('required')">
      To pole jest wymagane
    </mat-error>

    <mat-error *ngIf="control.hasError('backendError')">
      {{ control.getError('backendError') }}
    </mat-error>
  </mat-form-field>

  <mat-chip-list
    *ngIf="hasSelectedArticles"
    class="dict-dobry-agent-blog-articles__chips"
    aria-label="Wybrane powiązane artykuły"
  >
    <mat-chip
      *ngFor="let article of selectedItems"
      [removable]="!control.disabled"
      (removed)="removeArticle(article)"
    >
      {{ article.name }}

      <mat-icon
        *ngIf="!control.disabled"
        matChipRemove
      >
        cancel
      </mat-icon>
    </mat-chip>
  </mat-chip-list>
</div>
